import gql from 'graphql-tag'

export default gql`query user($user_id: Int!){
  user(user_id: $user_id){
    user_id
    schedules{
      id
      start_date
      end_date
      project_activity_budget{
        id
        project_id
        project{
          name
        }
        description
        stage
        address{
          full_address
        }
      }
      user_project_activities{
        project_id
        project_activity_budget{
          id
          description
          project_activity_type{
            project_activity_type_id
            description
          }
        }
      }
    }
  }
}`